// ABOUTME: The order figures panel: what a period shipped, beside those orders over time.
// ABOUTME: Takes an optional relationId, so the same panel serves the overview and one relation.

import { useTranslation } from "react-i18next";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import PublicIcon from '@mui/icons-material/Public';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetOrderDashboardChartQuery, useGetOrderDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const OrderTotalsPanel = ({ relationId }) => {
    const { t } = useTranslation();

    return (
        <ShTotalsPanel
            useTotals={useGetOrderDashboardTotalsQuery}
            useChart={useGetOrderDashboardChartQuery}
            filter={relationId ? { relationId } : undefined}
            chartSubtitles={{
                month: t("orders_per_month"),
                week: t("orders_per_week")
            }}
            chartSeries={[
                { type: "number" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={[
                { key: "orderCount", label: t("orders_shipped"), icon: <LocalShippingIcon className="logo"/>, color: "blue", type: "number" },
                { key: "orderLineCount", label: t("orderlines"), icon: <FormatListBulletedIcon className="logo"/>, color: "purple", type: "number" },
                { key: "singleCount", label: t("single_orders"), icon: <LooksOneOutlinedIcon className="logo"/>, color: "orange", type: "number" },
                { key: "countryCount", label: t("countries"), icon: <PublicIcon className="logo"/>, color: "green", type: "number" },
            ]}
        />
    );
};

export default OrderTotalsPanel;
